import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/Button';
import './Header.css';

const NAV = [
  { href: '#what-it-does', label: 'What it does' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#how-it-works', label: 'How it works' },
];

export function Header() {
  const [open, setOpen] = useState(false);

  // Lock body scroll while the mobile panel is open, so the page behind it
  // doesn't slide under the fixed overlay.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  // Escape closes the panel — expected of anything modal.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <a href="#top" className="site-header__brand" aria-label="CareBee — home">
          <img
            src="/assets/logos/carebee-lockup-light.svg"
            alt="CareBee by AXIMEDIC"
            width={140}
            height={31}
          />
        </a>

        <nav className="site-header__nav" aria-label="Main">
          {NAV.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="site-header__actions">
          <Button as="a" href="#request-access" variant="honey">
            Request access
          </Button>
        </div>

        <button
          type="button"
          className="site-header__toggle"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <span aria-hidden="true">{open ? '✕' : '☰'}</span>
        </button>
      </div>

      <div id="mobile-nav" className={`mobile-nav${open ? ' mobile-nav--open' : ''}`} hidden={!open}>
        <nav aria-label="Mobile">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
        </nav>
        <Button as="a" href="#request-access" variant="honey" block onClick={() => setOpen(false)}>
          Request access
        </Button>
      </div>
    </header>
  );
}
